export function removeHttp (src) {
  if (!src) return src

  if (typeof src === 'object' && src.backgroundImage) {
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '')
    return src
  }

  return src.replace(/^http(s?):/, '')
}
